import React from "react";
import "./_SelectButton.scss";

export const SelectButton = ({
  buttonText,
  color = "grey-black",
  onClick,
  id,
}) => {
  return (
    <div onClick={onClick} className={`select-button ${color}`} id={id}>
      {buttonText}
    </div>
  );
};
